import React from 'react';
import {Tooltip} from 'react-tooltip';
import PropTypes from 'prop-types';
import './styles.scss';

export default function InspectionTags({
  id, // Use id for tooltip
  tooltipText,
  icon,
  text,
  tagType, // Use types to work styles
}) {
  return (
    <>
      <div
        className={`inspectionTags inspectionTags_${tagType}`}
        data-tooltip-id={id}
        data-tooltip-content={tooltipText}
      >
        <div className={`inspectionTags_${tagType}_icon`}>{icon}</div>
        <div className={`inspectionTags_${tagType}_text`}>{text}</div>
      </div>
      <Tooltip id={id} place='bottom' />
    </>
  );
}

InspectionTags.propTypes = {
  id: PropTypes.string.isRequired, // Use id for tooltip
  text: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired, // Use id for tooltip
  icon: PropTypes.element.isRequired,
  tagType: PropTypes.oneOf(['NFC', 'WEB', 'NOTE', 'NO_NFC']).isRequired, // Use types to work styles
};
